<template>
  <div v-if="data.length > 0" class="file-list">
    <div class="ware-files">
      <div class="ware-file" v-for="(item, index) in data" :key="index">
        <div class="ware-file_icon" :class="{ [getFileTypeName(item.docType)]: true }"></div>
        <div class="ware-file_name" @click="onPreview(item)">
          {{ item.ware_filename }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Filelist',
  props: {
    fileList: {
      type: Array,
      default: () => [],
    },
    period: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    fileList: {
      immediate: true,
      deep: true,
      handler(value) {
        this.data = [...value];
        this.getChildren();
      },
    },
  },
  data() {
    return {
      records: [],
      data: [],
    };
  },

  methods: {
    getChildren() {
      this.data.forEach((f) => {
        if (
          /\.(wma|mp4|aac|flac|m4a|oga|opus|3gp|mpg|mpeg|3g2|avi|flv|h264|m4v|mj2|mov|ogg|ogv|rm|rmvb|qt|webm)$/i.test(
            f.ware_filename,
          )
        ) {
          f.type = 'video';
        } else if (/\.(doc|docx)$/i.test(f.ware_filename)) {
          f.type = 'word';
        } else if (/\.(xls|xlsx)$/i.test(f.ware_filename)) {
          f.type = 'excel';
        } else if (/\.(pdf)$/i.test(f.ware_filename)) {
          f.type = 'pdf';
        } else if (/\.(ppt|pptx)$/i.test(f.ware_filename)) {
          f.type = 'ppt';
        } else if (/\.(zip)$/i.test(f.ware_filename)) {
          f.type = 'zip';
        } else if (/\.(mp3|wav|wmv)$/i.test(f.ware_filename)) {
          f.type = 'audio';
        } else {
          f.type = 'file';
        }
      });
    },
    onFileClick(file) {
      if (!file.ware_url) {
        return;
      }
      window.open(file.ware_url);
    },
    async onPreview(file) {
      this.$webSeeSendTrack({
        event_id: 'my_courses_picture_class_click',
        event_type: 'click',
        data: {
          period_id: this.period.periods_id,
          period_title: this.period.periods_title,
          period_type: this.period.periods_type,
          file_name: file.file_name,
        },
      });
      if (file.type == 'video' || file.type == 'audio') {
        let data = await this.$http.get('/api/app/user/CourseWare/video/preview', {
          video_id: file.fid,
        });
        // window.open(data[0].url);
        this.open(data[0].url);
      } else {
        let data = await this.$http.get('/api/app/user/CourseWare/preview', {
          fid: file.fid,
        });
        // window.open(data);
        this.open(data);
      }
    },
    open(url) {
      let hasOrigin = false;
      try {
        const urlObj = new URL(url);
        // 如果 URL 对象成功创建，并且 origin 属性存在
        hasOrigin = !!urlObj.origin;
      } catch (e) {
        // 如果 URL 对象创建失败（例如，urlString 不是一个有效的 URL），则返回 false
        hasOrigin = false;
      }
      url = hasOrigin ? url : `${location.origin}${url}`;

      //桌面端内
      if (this.$store.state.desktop) {
        // 支持安全锁的版本
        if (this.$store.state.desktop.deviceInfo) {
          this.$router.push({
            name: 'Iframe',
            query: {
              url: this.ensureHttps(url),
            },
          });
        } else {
          this.$store.state.desktop.openurl(this.ensureHttps(url)); // 不支持安全锁的版本
        }
      } else {
        //桌面端外
        window.open(url);
      }
    },
    ensureHttps(url) {
      // 使用 URL 对象解析输入的 URL
      const parsedUrl = new URL(url);

      // 检查协议是否为 'https:'
      if (parsedUrl.protocol !== 'https:') {
        // 如果不是 'https:'，则修改为 'https:'
        parsedUrl.protocol = 'https:';
      }

      // 返回修改后的 URL 字符串
      return parsedUrl.toString();
    },
  },
};
</script>
<style lang="scss" scoped>
.ware-files {
  padding-right: 20px;
}
.ware-file {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  margin-bottom: 8px;
}
// .ware-file:last-child {
//   margin-bottom: 0;
// }
.ware-file_name {
  flex: 1;
  cursor: pointer;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  color: #333333;
  line-height: 26px;
  width: 0;
  word-wrap: break-word;
  &:hover {
    color: $primary-color;
  }
}
.ware-file_download {
  color: #999;
  cursor: pointer;
}
.ware-file_download-icon {
  width: 12px;
  height: 12px;
  margin-right: 2px;
}
.ware-file_icon {
  width: 26px;
  height: 26px;
  background-size: 100% 100%;
  margin-right: 8px;
  flex-shrink: 0;
}
.ware-file_icon-file {
  background-image: url('~@/modules/stu/images/file/file_icon_3@2x.png');
}
.ware-file_icon-excel {
  background-image: url('~@/modules/stu/images/file/xlsx_icon@2x.png');
}
.ware-file_icon-pdf {
  background-image: url('~@/modules/stu/images/file/pdf_icon@2x.png');
}
.ware-file_icon-ppt {
  background-image: url('~@/modules/stu/images/file/ppt_icon@2x.png');
}
.ware-file_icon-video {
  background-image: url('~@/modules/stu/images/file/video_icon_1@2x.png');
}
.ware-file_icon-word {
  background-image: url('~@/modules/stu/images/file/doc_icon@2x.png');
}
.ware-file_icon-zip {
  background-image: url('~@/modules/stu/images/file/zip@2x.png');
}
.ware-file_icon-audio {
  background-image: url('~@/modules/stu/images/file/audio_icon@2x.png');
}
</style>
